export default "__VITE_ASSET__BlrcDXfI__"